import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

export default function MatchOverDialog({ gameState, onNewMatch, onBackMenu }) {
  const navigate = useNavigate()
  const dialogRef = useRef(null)
  const previousFocus = useRef(null)

  useEffect(() => {
    if (gameState?.match_over || gameState?.phase === 'fim_da_partida') {
      previousFocus.current = document.activeElement
      const firstBtn = dialogRef.current?.querySelector('button')
      if (firstBtn) firstBtn.focus()
    } else if (previousFocus.current) {
      previousFocus.current.focus()
      previousFocus.current = null
    }
  }, [gameState])

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key !== 'Tab') return
      const dialog = dialogRef.current
      if (!dialog) return
      const focusable = dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }

    if (gameState?.match_over || gameState?.phase === 'fim_da_partida') {
      window.addEventListener('keydown', handleKeyDown)
      return () => window.removeEventListener('keydown', handleKeyDown)
    }
  }, [gameState])

  if (!gameState || (!gameState.match_over && gameState.phase !== 'fim_da_partida')) {
    return null
  }

  const winner = gameState.winner
  const score = gameState.score
  const text = winner === 'jogador'
    ? `Parabéns! Você venceu a partida! Placar final: Você ${score.player} × ${score.bot} Computador.`
    : `O computador venceu a partida. Placar final: Você ${score.player} × ${score.bot} Computador.`

  return (
    <div
      ref={dialogRef}
      id="match-over-dialog"
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="match-over-heading"
    >
      <div className="modal-content">
        <h2 id="match-over-heading">Fim da partida</h2>
        <p id="match-over-text">{text}</p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-primary btn-large"
            id="btn-new-match"
            onClick={onNewMatch}
          >
            Nova partida
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-large"
            id="btn-back-menu"
            onClick={() => { onBackMenu(); navigate('/menu') }}
          >
            Voltar ao menu
          </button>
        </div>
      </div>
    </div>
  )
}
